import { render, staticRenderFns } from "./renewal_reminders_tab.vue?vue&type=template&id=c4fd1b7e"
import script from "./renewal_reminders_tab.vue?vue&type=script&lang=js"
export * from "./renewal_reminders_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports